<template>
  <div>
    <Header v-if="!blank" />
    <Banner v-if="!isFixed" />
    <router-view />
    <Footer v-if="!blank" />
  </div>
</template>
<script>
import { mapState } from "vuex";

const BLACK_PAGE = {
  "/reservation": true,
};

export default {
  computed: {
    ...mapState({
      isFixed: (state) => state.header.isFixed,
    }),
    blank() {
      return BLACK_PAGE[this.$route.path];
    },
  },
};
</script>
